import "./js/mobile-menu";
import "./js/collapsible-menu";
import "./js/header-menu";
import "./js/header-shadow-after-scroll";
// import "./js/fetch-handler-bond-ua";
import "./js/fetch-handler";
import "./js/language-toggler";
